import React from 'react';
import { Button } from '@/components/ui/button';
import { SparklesIcon } from '@/components/icons/sparkles-icon';
import BackButton from '@/components/navigation/BackButton';
import routes from '@/config/routes';
import { ProductStatus } from '@/types';

interface GenerateTopBarProps {
  product: {
    status: ProductStatus;
    slug: string;
    shop: {
      slug: string;
    };
  };
}

export const GenerateTopBar: React.FC<GenerateTopBarProps> = ({ product }) => {
  return (
    <div className="sticky top-0 z-20 -mx-4 mb-4 flex items-center justify-between bg-white p-4 dark:bg-black sm:static sm:top-auto sm:z-0 sm:m-0 sm:mb-4 sm:bg-transparent sm:p-0 sm:dark:bg-transparent">
      <BackButton />
      {product.status === ProductStatus.Draft && (
        <a href={routes.editProductUrl(product.slug, product.shop.slug)}>
          <Button className="flex items-center gap-2 rounded-full bg-brand px-6 py-2 text-white shadow-lg transition-all hover:bg-brand/90 hover:shadow-xl">
            <SparklesIcon className="h-5 w-5" />
            <span>Publish & Earn Money</span>
          </Button>
        </a>
      )}
    </div>
  );
}; 